import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=d778c1f2&scoped=true&"
import script from "./Legends.vue?vue&type=script&lang=js&"
export * from "./Legends.vue?vue&type=script&lang=js&"
import style0 from "./Legends.vue?vue&type=style&index=0&id=d778c1f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d778c1f2",
  null
  
)

export default component.exports